export const couponTypes = {
  LIFETIME: 'lifetime',
  DISCOUNT_MONTHS: 'discount for few months',
  FREE_MONTHS: 'few free months',
};

export default function getCouponType(coupon) {
  if (coupon) {
    if (coupon.discountPercent === 100) {
      return couponTypes.FREE_MONTHS;
    } else if (coupon.durationInMonth === null) {
      return couponTypes.LIFETIME;
    }
    return couponTypes.DISCOUNT_MONTHS;
  }
  return '';
}
